import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Paper, Typography, Tabs, Tab, Select, MenuItem, IconButton } from '@mui/material';
import { ArrowBack } from "@mui/icons-material";
import Grid from '@mui/material/Grid2';
import axios from 'axios';
import PieChartMoviment from '../components/common/PieChartMoviment.js';
import MonthlyBalanceListAnual from '../components/dashboard-anual/MonthlyBalanceListAnual';
import ConceptList from '../components/common/ConceptList';
import ConceptHierarchyList from '../components/common/ConceptHierarchyList';
import AppContext from '../components/AppContext'; 
import Saldo from '../components/common/Saldo';
import { listAnys } from '../functions/common-lists.js';
import DataLoader from '../components/common/DataLoader.js';
import config from '../config.js';
import PieChartAgrupacio from '../components/common/PieChartAgrupacio.js';
import { calculaAgrupacioConceptes } from '../functions/agrupacio-conceptes.js';
//import useBack from '../hooks/useBack.js';

const DashboardAnual = () => {
  const { ctxApp, setCtxApp } = useContext(AppContext);
  const [tabValue, setTabValue] = useState(ctxApp?.dashboardAnualTabSelected || 0);
  const [viewMode, setViewMode] = useState('estalvi'); // 'estalvi' (default) -> 'inversiones' -> 'actual'
  
  const { userapp: paramUserapp, anyo: paramAnyo } = useParams();
  const userapp = paramUserapp;
  const anyo = paramAnyo;  

  const navigate = useNavigate();

  const handleToggleViewMode = () => {
    setViewMode(prev => {
      if (prev === 'estalvi') return 'inversiones';
      if (prev === 'inversiones') return 'actual';
      return 'estalvi';
    });
  };

  //const { onBack } = useBack();
  const gotoBack = () => {
    navigate(`/${userapp}/dashboard`);
    //onBack();
  }; 

  const fetchFunction = (jwtToken, onData, onError, onFinally) => {
    axios.get(`${config.apiBaseUrl}/v1/resumanual/${userapp}/${anyo}`, {
      headers: { Authorization: `${jwtToken}`}
    })
    .then((response) => {
      onData(response);

      const newCtxData = {
        ...ctxApp,
        numConceptePendent: response.data.numConceptePendent || 0,
        numDesglosPendent: response.data.numDesglosPendent || 0,
        numPendentValidar: response.data.numPendentValidar || 0,
        numPendentTotal: (response.data.numConceptePendent || 0) + (response.data.numDesglosPendent || 0) + (response.data.numPendentValidar || 0)
      };
      setCtxApp(newCtxData);
    })
    .catch((err) => {
      onError(err, 'cargar datos');
    })
    .finally(() => onFinally());
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setCtxApp(prev => ({ ...prev, dashboardAnualTabSelected: newValue }));
  };

  const handleYear = (anio) => {
    navigate(`/${userapp}/dashboard/${anio}`);
  };   

  return (
    <DataLoader id={anyo} fetchFunction={fetchFunction}>
      {(data) => {
        const listDespesesPrincipals = data 
          ? Object.values(data.mapAgregatMovimentsAnual)
            .filter(v => v.importAgregat.saldo < 0)
          : [];
        const listIngresosPrincipals = data
          ? Object.values(data.mapAgregatMovimentsAnual)
            .filter(v => v.importAgregat.saldo > 0)
          : [];

        const agrupacioConceptes = calculaAgrupacioConceptes(data.mapAgregatConceptes);
        const listAgrupacioConceptesDespeses = data 
          ? Object.values(agrupacioConceptes)
            .filter(v => v.tipus === 'DESPESA')
          : [];          
        const listAgrupacioConceptesIngressos = data 
          ? Object.values(agrupacioConceptes)
            .filter(v => v.tipus === 'INGRES')
          : [];          
          
        // Calcular desinversiones e inversiones del total de conceptos
        let desinversiones = 0;
        let inversiones = 0;
        if (data.mapAgregatConceptes) {
          Object.values(data.mapAgregatConceptes).forEach(item => {
            if (item.concepte?.tipus === 'INVERSIO') {
              const val = item.importAgregat?.saldo || 0;
              if (val > 0) {
                desinversiones += val;
              } else {
                inversiones += val;
              }
            }
          });
        }

        // Calcular valores según el modo de vista seleccionado
        let anualSaldo, anualIngressos, anualDespeses;
        let varSaldo, varIngressos, varDespeses;
        let mitjaSaldo, mitjaIngressos, mitjaDespeses;
        let desvSaldo, desvIngressos, desvDespeses;

        if (viewMode === 'estalvi') {
          anualSaldo = data.agregat?.importAgregat?.saldoEstalvi;
          anualIngressos = data.agregat?.importAgregat?.ingressos;
          anualDespeses = data.agregat?.importAgregat?.despeses;

          varSaldo = data.agregat?.variacioAnyAnterior ? data.agregat.variacioAnyAnterior.saldoEstalvi : 0;
          varIngressos = data.agregat?.variacioAnyAnterior ? data.agregat.variacioAnyAnterior.ingressos : 0;
          varDespeses = data.agregat?.variacioAnyAnterior ? data.agregat.variacioAnyAnterior.despeses : 0;

          mitjaSaldo = data.agregat?.importAgregat?.mitjaSaldoEstalvi;
          mitjaIngressos = data.agregat?.importAgregat?.mitjaIngressos;
          mitjaDespeses = data.agregat?.importAgregat?.mitjaDespeses;

          desvSaldo = data.agregat?.variacioMitjaAnys ? data.agregat.variacioMitjaAnys.saldoEstalvi : 0;
          desvIngressos = data.agregat?.variacioMitjaAnys ? data.agregat.variacioMitjaAnys.ingressos : 0;
          desvDespeses = data.agregat?.variacioMitjaAnys ? data.agregat.variacioMitjaAnys.despeses : 0;
        } else if (viewMode === 'inversiones') {
          anualSaldo = data.agregat?.importAgregat?.inversions;
          anualIngressos = desinversiones;
          anualDespeses = inversiones;

          varSaldo = data.agregat?.variacioAnyAnterior ? data.agregat.variacioAnyAnterior.inversions : 0;
          varIngressos = undefined;
          varDespeses = undefined;

          mitjaSaldo = data.agregat?.importAgregat?.mitjaInversions;
          mitjaIngressos = undefined;
          mitjaDespeses = undefined;

          desvSaldo = data.agregat?.variacioMitjaAnys ? data.agregat.variacioMitjaAnys.inversions : 0;
          desvIngressos = undefined;
          desvDespeses = undefined;
        } else { // actual
          anualSaldo = data.agregat?.importAgregat?.saldo;
          anualIngressos = (data.agregat?.importAgregat?.ingressos || 0) + desinversiones;
          anualDespeses = (data.agregat?.importAgregat?.despeses || 0) + inversiones;

          varSaldo = data.agregat?.variacioAnyAnterior ? data.agregat.variacioAnyAnterior.saldo : 0;
          varIngressos = undefined;
          varDespeses = undefined;

          mitjaSaldo = data.agregat?.importAgregat?.mitjaSaldo;
          mitjaIngressos = undefined;
          mitjaDespeses = undefined;

          desvSaldo = data.agregat?.variacioMitjaAnys ? data.agregat.variacioMitjaAnys.saldo : 0;
          desvIngressos = undefined;
          desvDespeses = undefined;
        }

        return (
        <>
          <Grid size={{xs: 12, sm: 6 }} sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
            <IconButton onClick={()=>gotoBack()}>
              <ArrowBack />
            </IconButton>

            <Typography variant="h5">
              Dashboard Anual
            </Typography>
            <Select
              value={data?.anio|| new Date().getFullYear()}
              label="Any"
              onChange={(e) => handleYear(e.target.value)}
            >
              {listAnys().map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid container spacing={2} sx={{ marginTop: '10px' }}>
            <Saldo titol="Saldo Anual" 
              saldo={anualSaldo} 
              ingressos={anualIngressos}
              despeses={anualDespeses}
              mode={viewMode}
              onToggleMode={handleToggleViewMode}
              showToggleIcon={true} />

            <Saldo titol="Dif. any anterior" 
              saldo={varSaldo} 
              ingressos={varIngressos}
              despeses={varDespeses}
              mode={viewMode}
              onToggleMode={handleToggleViewMode}
              showToggleIcon={true} />

            <Saldo titol="Mitja Mensual" 
              saldo={mitjaSaldo} 
              ingressos={mitjaIngressos}
              despeses={mitjaDespeses}
              mode={viewMode}
              onToggleMode={handleToggleViewMode}
              showToggleIcon={true} />

            <Saldo titol="Desviació Mitja Anual" 
              saldo={desvSaldo} 
              ingressos={desvIngressos}
              despeses={desvDespeses}
              mode={viewMode}
              onToggleMode={handleToggleViewMode}
              showToggleIcon={true} />

            {/* Tabbar */}
            <Grid size={12}>
              <Paper>
                <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" centered>
                  <Tab label="Mesos" />
                  <Tab label="Conceptes" />
                  <Tab label="Conceptes (Jeràrquic)" />
                </Tabs>

                {tabValue === 0 && (
                  <MonthlyBalanceListAnual months={data.mapAgregatMensual} defaultViewMode={viewMode} />
                )}
                {tabValue === 1 && (
                  <ConceptList concepts={data.mapAgregatConceptes} tipus="anual" viewMode={viewMode} />
                )}
                {tabValue === 2 && (
                  <ConceptHierarchyList userapp={userapp} anyo={data.anio} tipus="anual" viewMode={viewMode} />
                )}
              </Paper>
            </Grid>

            {/* Gráficos de ingresos y gastos principals*/ }
            <Grid size={{xs: 12, sm: 6, md: 6 }}>
              <PieChartMoviment data={listDespesesPrincipals} title="Despeses Principals" />
            </Grid>
            <Grid size={{xs: 12, sm: 6, md: 6 }}>
              <PieChartMoviment data={listIngresosPrincipals} title="Ingressos Principals" />
            </Grid>
            <Grid size={{xs: 12, sm: 6, md: 6 }}>
              <PieChartAgrupacio data={listAgrupacioConceptesDespeses} title="Despeses Agrupades" />
            </Grid>
            <Grid size={{xs: 12, sm: 6, md: 6 }}>
              <PieChartAgrupacio data={listAgrupacioConceptesIngressos} title="Ingressos Agrupats" />
            </Grid>            
          </Grid>
        </>
      );
      }}
    </DataLoader>
  );
};

export default DashboardAnual;
